class PanBuilder extends PanBuilderBase {

  render(view) {
    const { state: {
      curbType, grateStyle, drainPosition,
    } } = this;

    const funcMap = {
      top: {
        'Barrier Free': PanTopViewBF,
        'Single Curb': PanTopViewSC,
        'Left Dual Curb': PanTopViewDLC,
        'Right Dual Curb': PanTopViewDRC,
      },
      side: {
        'Barrier Free': {
          Round: PanSideViewBF,
          Trench: PanSideViewRTBF,
        },
        'Single Curb': {
          Round: PanSideViewSC,
          Trench: PanSideViewRTSC,
        },
        'Left Dual Curb': {
          Round: PanSideViewSC,
          Trench: PanSideViewRTSC,
        },
        'Right Dual Curb': {
          Round: PanSideViewSC,
          Trench: PanSideViewRTSC,
        },
      },
      front: {
        'Barrier Free': {
          Round: PanFrontViewBF,
          Trench: PanFrontViewRTSC,
        },
        'Single Curb': {
          Round: PanFrontViewSC,
          Trench: PanFrontViewRTSC,
        },
        'Left Dual Curb': {
          Round: PanFrontViewDLC,
          Trench: PanFrontViewRTDL,
        },
        'Right Dual Curb': {
          Round: PanFrontViewDRC,
          Trench: PanFrontViewRTDR,
        },
      },
    };

    if (
      funcMap[view] && funcMap[view][curbType] &&
      typeof funcMap[view][curbType] === 'function'
    ) return this.renderView(funcMap[view][curbType]);

    if (
      funcMap[view] && funcMap[view][curbType] &&
      typeof funcMap[view][curbType][grateStyle] === 'function'
    ) return this.renderView(funcMap[view][curbType][grateStyle]);

    if (
      funcMap[view] && funcMap[view][curbType] &&
      typeof funcMap[view][curbType][grateStyle][drainPosition] === 'function'
    ) return this.renderView(funcMap[view][curbType][grateStyle][drainPosition]);
  }

  renderView(renderMethod) {
    const { state: {
      scale, drainBackDistanceInches, drainSideDistanceInches, grateStyle,
      drainPosition, panWidthInches, panDepthInches, curbWidthInches, curbHeightInches,
    } } = this;

    const panWidth = Math.round(scale * panWidthInches);
    const panDepth = Math.round(scale * panDepthInches);
    const panHeight = Math.round(scale * panBaseSpec.height);
    const curbWidth = Math.round(scale * curbWidthInches);
    const curbHeight = Math.round(scale * curbHeightInches);
    const splashWallWidth = Math.round(scale * panBaseSpec.splashWallWidthInches);
    const circleDrain = Math.round(scale * panBaseSpec.drainTopDiameter);
    const plankFloorThickness = Math.round(scale * panBaseSpec.plankFloorThickness);
    const trenchFloorThickness = Math.round(scale * panBaseSpec.trenchFloorThickness);
    const drainSide = Math.round(scale * drainSideDistanceInches);
    const drainBack = Math.round(scale * drainBackDistanceInches);
    const drainOpening = Math.round(scale * panBaseSpec.drainOpening);
    const drainExposed = Math.round(scale * drainBaseSpec.drainDepthExposed);
    const floorThicknessInches = (grateStyle === 'Trench') ? panBaseSpec.trenchFloorThickness : panBaseSpec.plankFloorThickness;
    // Match the Trench section opening to the three-inch channel in top view.
    const drainPlateWidth = Math.round(scale * (
      grateStyle === 'Trench'
        ? drainBaseSpec.grateDepth
        : compressionDrainSpec.panOutsetWidth
    ));
    const drainDimensionWidth = drainOpening;
    const drainX = (drainPosition === 'Left') ? drainSide : panWidth - drainSide;
    const drainY = drainBack;

    const grateDepth = Math.round(drainBaseSpec.grateDepth * scale);
    const grateThickness = Math.round(drainBaseSpec.grateThickness * scale);

    let curbToDrain = panDepth - curbWidth - drainY - (drainPlateWidth / 2);

    if (drainPosition === 'Right' && grateStyle === 'Trench') {
      curbToDrain = panWidth - drainX - (drainPlateWidth / 2);
    }
    const depthRateOfDecline = curbToDrain / (12 * scale);

    const depthDeclineTotalInches = panBaseSpec.floorPitch * depthRateOfDecline;
    const depthDeclineTotal = Math.ceil(depthDeclineTotalInches * scale);

    const sideWallToDrain = panWidth - drainX - (drainPlateWidth / 2);
    const remainingFloor = drainX - (drainPlateWidth / 2);

    let widthRateOfDecline;

    if (sideWallToDrain > remainingFloor) {
      widthRateOfDecline = sideWallToDrain / (12 * scale);
    } else {
      widthRateOfDecline = remainingFloor / (12 * scale);
    }

    // Choose a largest distance to drain
    if (sideWallToDrain < remainingFloor) {
      widthRateOfDecline = remainingFloor / (12 * scale);
    }

    const widthDeclineTotalInches = panBaseSpec.floorPitch * widthRateOfDecline;
    const widthDeclineTotal = Math.round(widthDeclineTotalInches * scale);

    const drainWidth = Math.round(drainBaseSpec.drainWidth * scale);
    const drainHeight = plankFloorThickness + drainExposed;
    const drainInnerDiameter = Math.round(drainBaseSpec.drainInnerDiameter * scale);

    renderMethod.call(this, {
      panWidth,
      panDepth,
      panHeight,
      curbWidth,
      curbHeight,
      plankFloorThickness,
      trenchFloorThickness,
      splashWallWidth,
      circleDrain,
      drainSide,
      drainBack,
      drainX,
      drainY,
      drainOpening,
      drainHeight,
      drainWidth,
      drainInnerDiameter,
      drainPlateWidth,
      drainDimensionWidth,
      depthDeclineTotal,
      widthDeclineTotal,
      drainExposed,
      floorThicknessInches,
      depthDeclineTotalInches,
      widthDeclineTotalInches,
      drainPosition,
      grateStyle,
      grateDepth,
      grateThickness,
    });
  }
}
